import React from "react"
import { imageItemTransformer } from "../utils/transformers"
import Image, { ImageOptimProps } from "./ImageOptim"
import Video, { VideoProps } from "./Video"

interface BaseMediaProps {
  /**
   * the media content item
   */
  media: any
}

type FeaturedMediaProps = BaseMediaProps & (VideoProps | ImageOptimProps)

const FeaturedMedia = ({ media, ...props }: FeaturedMediaProps) => {
  if (!media) {
    return null
  }

  if (media.system.type === "image_element") {
    // Treat props as FeaturedPhotoProps
    const { cropRatio, cropWidth = 856 } = props as ImageOptimProps
    return (
      <Image
        {...imageItemTransformer(media)}
        cropRatio={cropRatio}
        cropWidth={cropWidth}
      />
    )
  } else if (media.system.type === "video") {
    // Treat props as FeaturedVideoProps
    const { playInModal } = props as VideoProps
    return <Video video={media} playInModal={playInModal} />
  } else {
    return null
  }
}

export default FeaturedMedia
